export const CurPricing = {
    "pricingMonthly": [
        {
            "plan": "Free Plan",
            "planId": "free2025",
            "price": {
                "inr": "0",
                "usd": "0"	
            },
            "term": "per month",
            "planFeatures": [
                "1 site",
                "3 MB total size",
                "25 MB max Assets size",
                "250 visits per month",
                "150 MB data transfer per month",
                "25 contact forms per month",
                "Community support",
            ],
            "subscriptionLink": {
                "buttonName": "Start for free",
                "buttonURL": "https://dashboard.turbosteed.com"
            }
        },
        {
            "plan": "Basic Plan",
            "planId": "basic2025",
            "price": {
                "inr": "149",
                "usd": "1.50"	
            },
            "term": "per month",
            "planFeatures": [
                "1 site",
                "5 MB total size",
                "100 MB max Assets size",
                "1000 visits per month",
                "250 MB data transfer per month",
                "50 contact forms per month",
                "Community support",
                "1 custom domain",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Beta Access",
                "buttonURL": "https://dashboard.turbosteed.com"
            }
        },
        {
            "plan": "Startup Plan",
            "planId": "startup2025",
            "price": {
                "inr": "549",
                "usd": "6"	
            },
            "term": "per month",
            "planFeatures": [
                "2 sites",
                "25 MB total site size",
                "250 MB max Assets",
                "25000 visits per month",
                "5 GB data transfer per month",
                "250 contact forms per month",
                "Site Analytics",
                "1 custom domain",
                "Remove TurboSteed branding",
                "Custom 404 page",
                "Email support",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Contact Us",
                "buttonURL": "/contactus"
            }
        },
        {
            "plan": "Agency Plan",
            "planId": "agency2025",
            "price": {
                "inr": "Custom",
                "usd": "Custom"	
            },
            "term": "per month",
            "planFeatures": [
                "No site limit",
                "25 MB size per site",
                "150 MB Assets per site",
                "250000 visits per month",
                "100 GB data transfer per month",
                "5000 contact forms per month",
                "Site Analytics",
                "25 custom domains",
                "Custom branding in footer",
                "Custom 404 page",
                "Priority email support",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Contact Us",
                "buttonURL": "/contactus"
            }
        },
    ],

    "pricingYearly": [
        {
            "plan": "Free Plan",
            "planId": "free2025",
            "price": {
                "inr": "0",
                "discountINR": "0",
                "usd": "0",
                "discountUSD": "0"	
            },
            "term": "per year",
            "planFeatures": [
                "1 site",
                "3 MB total size",
                "25 MB max Assets size",
                "250 visits per month",
                "150 MB data transfer per month",
                "25 contact forms per month",
                "Community support",
            ],
            "subscriptionLink": {
                "buttonName": "Start for free",
                "buttonURL": "https://dashboard.turbosteed.com"
            }
        },
        {
            "plan": "Basic Plan",
            "planId": "basic2025",
            "price": {
                "inr": "1489",
                "discountINR": "1789",
                "usd": "15",
                "discountUSD": "18"
            },
            "term": "per year",
            "planFeatures": [
                "1 site",
                "5 MB total size",
                "100 MB max Assets size",
                "1000 visits per month",
                "250 MB data transfer per month",
                "50 contact forms per month",
                "Community support",
                "1 custom domain",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Beta Access",
                "buttonURL": "https://dashboard.turbosteed.com"
            }
        },
        {
            "plan": "Startup Plan",
            "planId": "startup2025",
            "price": "$59",
            "price": {
                "inr": "5489",
                "discountINR": "6589",
                "usd": "59",	
                "discountUSD": "72"
            },
            "term": "per year",
            "planFeatures": [
                "2 sites",
                "25 MB total site size",
                "250 MB max Assets",
                "25000 visits per month",
                "5 GB data transfer per month",
                "250 contact forms per month",
                "Site Analytics",
                "1 custom domain",
                "Remove TurboSteed branding",
                "Custom 404 page",
                "Email support",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Contact Us",
                "buttonURL": "/contactus"
            }
        },
        {
            "plan": "Agency Plan",
            "planId": "agency2025",
            "price": "$950",
            "price": {
                "inr": "Custom",
                "usd": "Custom"	
            },
            "term": "per year",
            "planFeatures": [
                "No site limit",
                "25 MB size per site",
                "150 MB Assets per site",
                "250000 visits per month",
                "100 GB data transfer per month",
                "5000 contact forms per month",
                "Site Analytics",
                "25 custom domains",
                "Custom branding in footer",
                "Custom 404 page",
                "Priority email support",
                "Contact forms in email (addon)"
            ],
            "subscriptionLink": {
                "buttonName": "Contact Us",
                "buttonURL": "/contactus"
            }
        },
    
    ],



}